import Drawable from '../entities/Drawable.js';
import StatusBadge from './StatusBadge.js';
import { c } from '../setup.js';
import PixelText from './PixelText.js';

export default class PlayerPokemonBattleInfoBox extends Drawable {
    constructor({ pokemon, sprites, position = { x: 0, y: 0 }, visible = true }) {
        super();
        this.pokemon = pokemon;
        this.sprites = sprites;
        this.position = position;
        this.visible = visible;
        this.sprites.statusBadge = new StatusBadge({
            position: { x: this.position.x + 8, y: this.position.y + 16 },
            status: this.pokemon.status1 ? this.pokemon.status1.id : 'blank',
        });
        this.xModifier = 0;
        this.yModifier = 0;
        this.lifetime = 0;
        this.showHpAsPercentage = false;

        this.pokemonName = new PixelText({
            text: '',
            position: {
                x: this.position.x + 15,
                y: this.position.y + 4,
            },
            color: 'black',
        });
        this.pokemonLevel = new PixelText({
            text: '',
            position: {
                x: this.position.x + 96,
                y: this.position.y + 4,
            },
            color: 'black',
            textAlign: 'right',
        });
        this.pokemonGender = new PixelText({
            text: '',
            position: {
                x: this.position.x + 96,
                y: this.position.y + 4,
            },
            color: 'black',
        });
        this.pokemonHP = new PixelText({
            text: '',
            position: {
                x: this.position.x + 100,
                y: this.position.y + 22,
            },
            color: 'black',
            textAlign: 'right',
        });
    }

    upDown() {
        if ((this.lifetime + 20) % 80 < 40) {
            this.yModifier = 1; // move up
        } else {
            this.yModifier = 0; // move down
        }
    }

    stopUpDown() {
        this.yModifier = 0;
    }

    draw() {
        this.lifetime += 1;
        if (!this.visible) {
            return;
        }

        const effectiveY = this.position.y + this.yModifier;
        this.sprites.battleScenePlayerInfo.yModifier = this.yModifier;
        this.sprites.battleScenePlayerInfo.draw();

        const barShouldBeRed = this.pokemon.stats.hp < this.pokemon.stats.maxHp * 0.2;
        const barShouldBeYellow = this.pokemon.stats.hp < this.pokemon.stats.maxHp * 0.5;

        c.fillStyle = Drawable.blackBarColor;
        c.fillRect(this.position.x + 48, effectiveY + 17, 48, 3);

        // Health Bar
        c.fillStyle = barShouldBeRed
            ? Drawable.redBarColor
            : barShouldBeYellow
            ? Drawable.yellowBarColor
            : Drawable.greenBarColor;
        c.fillRect(
            this.position.x + 48,
            effectiveY + 17,
            Math.ceil(48 * (this.pokemon.stats.hp / this.pokemon.stats.maxHp)),
            3
        );
        c.fillStyle = barShouldBeRed
            ? Drawable.redBarShadow
            : barShouldBeYellow
            ? Drawable.yellowBarShadow
            : Drawable.greenBarShadow;
        c.fillRect(
            this.position.x + 48,
            effectiveY + 17,
            Math.ceil(48 * (this.pokemon.stats.hp / this.pokemon.stats.maxHp)),
            1
        );

        // Experience Bar
        c.fillStyle = Drawable.blueBarColor;
        const currentLevelExperience = this.pokemon.getCurrentLevelExperience();
        const nextLevelExperience = this.pokemon.getNextLevelExperience();

        const experienceBarProgress =
            ((this.pokemon.experience - currentLevelExperience) /
                (nextLevelExperience - currentLevelExperience)) *
            64;

        c.fillRect(this.position.x + 32, effectiveY + 33, experienceBarProgress, 2);

        // Gender symbol setup
        let genderString = '';
        let genderColor = null;

        if (this.pokemon.gender === 'Female') {
            genderString = '\u2640 ';
            genderColor = 'red';
        }
        if (this.pokemon.gender === 'Male') {
            genderString = '\u2642 ';
            genderColor = 'blue';
        }

        const levelText = `Lv${this.pokemon.level}`;

        // Draw Pokemon name
        this.pokemonName.text = this.pokemon.nickname || this.pokemon.name;
        this.pokemonName.position.x = this.position.x + 15;
        this.pokemonName.position.y = effectiveY + 4;
        this.pokemonName.draw();

        // Draw level text
        this.pokemonLevel.text = levelText;
        this.pokemonLevel.position.x = this.position.x + 96;
        this.pokemonLevel.position.y = effectiveY + 4;
        this.pokemonLevel.draw();

        // Draw gender symbol
        this.pokemonGender.text = genderString;
        if (genderString) {
            this.pokemonGender.setColor(genderColor);
            this.pokemonGender.position.x =
                this.pokemonLevel.position.x - this.pokemonLevel.measureTextWidth(this.pokemonLevel.text) - 6;
            this.pokemonGender.position.y = effectiveY + 4;
            this.pokemonGender.draw();
        }

        // Draw HP text
        const hpText = this.showHpAsPercentage
            ? `${Math.ceil((this.pokemon.stats.hp / this.pokemon.stats.maxHp) * 100)}%`
            : `${Math.ceil(this.pokemon.stats.hp)}/${this.pokemon.stats.maxHp}`;
        this.pokemonHP.text = hpText;
        this.pokemonHP.position.x = this.position.x + this.sprites.battleScenePlayerInfo.image.width - 8;
        this.pokemonHP.position.y = effectiveY + 22;
        this.pokemonHP.draw();

        if (this.pokemon.status1) {
            this.sprites.statusBadge.status = this.pokemon.status1.id;
            this.sprites.statusBadge.position.x = this.position.x + 9;
            this.sprites.statusBadge.position.y = effectiveY + 22;
            this.sprites.statusBadge.draw();
        }
    }
}
